<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title> {{ getText(process.globalizationConfig, 'title') }}</ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="dismiss()" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
    <ion-toolbar color="primary" search mode="md">
        <ion-searchbar
                mode="ios"
                class="section-search-custom"
                [placeholder]="'generic.searchByName' | translate"
                (keyup)="updateSearch($event.target.value)"
        ></ion-searchbar>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-row header hidden-tab>
        <ion-col size="12" [sizeLg]="hasImpersonate || hasControlProcess ? 3 : 4">
            {{ 'generic.user' | translate }}
        </ion-col>
        <ion-col size="6" [sizeLg]="hasImpersonate || hasControlProcess ? 2 : 3">
            {{ 'generic.country' | translate }}
        </ion-col>
        <ion-col size="6" [sizeLg]="hasImpersonate || hasControlProcess ? 2 : 3">
            {{ 'generic.group' | translate }}
        </ion-col>
        <ion-col size="6" size-lg="2">Status</ion-col>
        <ng-container *ngIf="hasImpersonate || hasControlProcess">
            <ion-col size="6" size-lg="1">
                {{ 'generic.actions' | translate }}
            </ion-col>
        </ng-container>
        <ng-container *ngIf="hasImpersonate">
            <ion-col size="6" size-lg="1">
                {{ 'processParticipants.personification' | translate }}
            </ion-col>
            <ion-col size="6" size-lg="1"> {{ 'generic.edit' | translate }}</ion-col>
        </ng-container>
    </ion-row>

    <ion-row llrm *ngFor="let user of users">
        <ion-col size="12" [sizeLg]="hasImpersonate || hasControlProcess ? 3 : 4" class="ion-align-self-center">
            <p hidden-desktop-lg>{{ 'generic.user' | translate }}</p>
            <div class="user">
                <img [src]="getImageUrl(user.imageUrl)" default="" alt=""/>
                <h2>{{ user.name }}</h2>
            </div>
        </ion-col>
        <ion-col size="6" [sizeLg]="hasImpersonate || hasControlProcess ? 2 : 3" class="ion-align-self-center">
            <p hidden-desktop-lg>{{ 'generic.country' | translate }}</p>
            <p>{{ user.attribute1 | uppercase }}</p>
        </ion-col>
        <ion-col size="6" [sizeLg]="hasImpersonate || hasControlProcess ? 2 : 3" class="ion-align-self-center">
            <p hidden-desktop-lg>{{ 'generic.group' | translate }}</p>
            <p>{{ user.attribute2 | uppercase }}</p>
        </ion-col>
        <ion-col size="6" size-lg="2" class="ion-align-self-center">
            <p hidden-desktop-lg>Status</p>
            <ion-text [color]="getColorByStatus(user.status)">
                {{ CycleUserStatus[user.status] | translate | uppercase }}
            </ion-text>
        </ion-col>
        <ion-col size="6" size-lg="1" class="ion-align-self-center" *ngIf="hasImpersonate || hasControlProcess">
            <p hidden-desktop-lg>{{ 'processParticipants.reopen' | translate }}</p>
            <ng-container *ngIf="user.status > ProcessStatus.NotEnabled">
                <ng-container *ngIf="cycle.closed">
                    <ion-text>
                        {{ 'performanceCycle.closedCycle' | translate }}
                    </ion-text>
                </ng-container>
                <ng-container *ngIf="process.id == 2 && !cycle.closed ">
                    <ion-button
                            *ngIf="user.isInCycle"
                            mode="ios"
                            [color]="isOpen(user.status) ? 'danger' : 'secondary'"
                            (click)="resolveProcess(user)"
                    >
                        {{
                            (isOpen(user.status) ? 'generic.close' :
                                    'processParticipants.reopen') | translate
                        }}
                    </ion-button>
                    <ion-text *ngIf="!user.isInCycle">
                        {{ 'processParticipants.notApplicable' | translate }}
                    </ion-text>
                </ng-container>
                <ng-container *ngIf="process.id !== 2 && !cycle.closed">
                    <ion-button
                            mode="ios"
                            [color]="isOpen(user.status) ? 'danger' : 'secondary'"
                            (click)="resolveProcess(user)"
                    >
                        {{
                            (isOpen(user.status) ? 'generic.close' :
                                    'processParticipants.reopen') | translate
                        }}
                    </ion-button>
                </ng-container>
            </ng-container>
            <ng-container
                    *ngIf="user.status == ProcessStatus.NotEnabled && !cycle.closed"
            >
                <ion-button mode="ios" [color]="'secondary'" (click)="enableStep(user)">
                    {{ 'processParticipants.enableStep' | translate }}
                </ion-button>
            </ng-container>
        </ion-col>
        <ng-container *ngIf="user.isGloballyVisible || isAdmin">
            <ion-col
                    size="6"
                    size-lg="1"
                    class="ion-align-self-center"
                    *ngIf="hasImpersonate && user.lineManagerId !== userId && user.userId !== userId"
            >
                <p hidden-desktop-lg>{{ 'generic.personification' | translate }}</p>
                <ion-button
                        mode="ios"
                        fill="clear"
                        color="primary"
                        type="button"
                        (click)="impersonateUser(user, 'dashboard')"
                >
                    <ion-icon class="bp-view"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col
                    size="6"
                    size-lg="1"
                    class="ion-align-self-center"
                    *ngIf="(user.lineManagerId == userId)"
                    title="Subordinado direto. Personificação não permitida"
            >
                <p hidden-desktop-lg>Subordinado direto</p>
                <ion-button
                        mode="ios"
                        fill="clear"
                        color="primary"
                        type="button"
                        disabled
                >
                    <ion-icon class="bp-view"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col
                    size="6"
                    size-lg="1"
                    class="ion-align-self-center"
                    *ngIf="hasImpersonate 
                    && user.lineManagerId !== userId 
                    && user.userId !== userId 
                    && user.status !== ProcessStatus.NotEnabled"
            >
                <p hidden-desktop-lg>{{ 'generic.edit' | translate }}</p>
                <ion-button
                        mode="ios"
                        fill="clear"
                        color="primary"
                        type="button"
                        (click)="impersonateUser(user, 'edit')"
                >
                    <ion-icon class="bp-edit"></ion-icon>
                </ion-button>
            </ion-col>
        </ng-container>
    </ion-row>

    <ion-row *ngIf="hasLoadMore">
        <ion-col class="load-more" size="12" size-md="12">
            <ion-button color="primary" fill="solid" mode="ios" (click)="loadMore()">
                {{ 'generic.loadMore' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-content>
